<template>
    <div class="section-box sent-post">
        <el-row class="row-bg">
            <el-col :span="12" style="text-align: left;line-height: 36px;">
                <el-button size="mini" :class="form.ProtocolType ==1 ?'selected':''" @click="chose(1)">使用协议</el-button>
                <el-button size="mini" style="margin-left: 25px;" :class="form.ProtocolType ==2 ?'selected':''" @click="chose(2)">隐私条款</el-button>
            </el-col>
            <el-col :span="12" style="text-align: right;">
                <el-button size="medium" type="primary" icon="el-icon-plus" plain @click="addContract" v-if="!(typeof(actionData.agreement_add) != 'undefined'&&!actionData.agreement_add)">新增</el-button>
                <el-button size="medium" type="primary" @click="handleSearch">查询</el-button>
                <el-button size="medium" type="success" @click="handleReset">重置</el-button>
            </el-col>
        </el-row>

        <!-- 列表 -->
        <el-table
            :stripe="true"
            :data="tableData"
            style="width: 100%"
            height="666"
            border
            v-loading="listLoading" 
            >
            <!-- eslint-disable  -->
            <el-table-column label="协议编号" >
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.ProtocolNo" placeholder="输入关键字搜索" />
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.ProtocolNo || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="协议版本">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.ProtocolVersion" placeholder="输入关键字搜索" />
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.ProtocolVersion || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="协议名称">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.ProtocolName" placeholder="输入关键字搜索" />
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.ProtocolName || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="添加时间" >
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-date-picker 
                            size="mini" 
                            v-model="form.CreateTime" 
                            type="daterange" 
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd" 
                            range-separator="—" 
                            start-placeholder="开始日期"
                            end-placeholder="结束日期" 
                            style="width: 100%">
                        </el-date-picker>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.CreateTime || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="协议文件">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.ProtocolFileName" placeholder="输入关键字搜索" />
                    </template>
                    <template slot-scope="scope">
                        <el-link :href="scope.row.ProtocolFileUrl" target="_blank" v-if="scope.row.ProtocolFileName">
                            <span>{{scope.row.ProtocolFileName}}</span>
                        </el-link>
                        <span v-else>--</span>
                    </template>
                </el-table-column>
            </el-table-column>
        </el-table>
        <div style="margin: 10px;overflow: hidden">
            <div style="float: right;" v-show="tableData.length">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="form.PageIndex"
                    :page-sizes="[10, 20, 50, 100, 200]"
                    :page-size="form.PageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
                </el-pagination>
            </div>
        </div>
        <el-dialog 
            :title="dialogTitle" 
            :visible.sync="showContract" 
            :close-on-click-modal="false" 
            width="600px" 
            ref="dialog"
        >
            <el-form ref="ruleForm" label-width="80px" class="add-form">
                <el-form-item label="版本">
                    <el-input v-model.trim="addForm.ProtocolVersion" placeholder="请输入版本" maxlength="50"></el-input>
                </el-form-item>
                <el-form-item label="名称">
                    <el-input v-model.trim="addForm.ProtocolName" placeholder="请输入名称" maxlength="50"></el-input>
                </el-form-item>
                <el-form-item label="链接" prop="address">
                    <el-input v-model.trim="addForm.ProtocolLinkUrl" placeholder="请输入连接"></el-input>
                </el-form-item>
                <el-form-item label="文件">
                    <div v-if="addForm.ProtocolFileUrl">
                        <div class="itmes-file">
                            <i class="delete-this-dom" @click="addForm.ProtocolFileUrl=''">
                                <svg t="1572586652683" class="icon" viewBox="0 0 1024 1024" version="1.1" p-id="3106" width="12" height="12">
                                    <path d="M882.048 209.216L209.28 882.048c-18.624 18.56-48.768 18.56-67.328 0s-18.56-48.704 0-67.328L814.72 141.952c18.624-18.56 48.768-18.56 67.328 0 18.56 18.56 18.56 48.704 0 67.264z" fill="#f75959" p-id="3107"></path>
                                    <path d="M882.048 882.048c-18.56 18.56-48.704 18.56-67.328 0L141.952 209.216c-18.56-18.624-18.56-48.704 0-67.264 18.56-18.56 48.704-18.56 67.328 0L882.048 814.72c18.56 18.624 18.56 48.768 0 67.328z" fill="#f75959" p-id="3108"></path>
                                </svg>
                            </i>
                            <el-link :href="addForm.ProtocolFileUrl" target="_blank" class="img-item">
                                <img src="~@/assets/icon/icon_pdf.jpg" />
                            </el-link>
                        </div>
                    </div>
                    <div v-else>
                        <el-upload
                            style="display: inline-block;vertical-align: top;"
                            :action="url"
                            list-type="picture-card"
                            :show-file-list="false"
                            :before-upload="uploadPreview"
                            accept=".pdf"
                            :on-success="protocolFileSuccess"
                        >
                            <i class="el-icon-plus"></i>
                        </el-upload>
                    </div>
                    <span class="tips">注:请上传pdf格式,大小不超过100MB</span>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="save()">保存</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
import apiEnv from "@/service/apiEnv.js";
import {
    ListContractTerms,       //获取协议列表
    AddContractTerms,            //新增协议
} from "@/service/contract";
import { 
    getActionData
} from '@/utils/store'
  export default {
    data() {
        return {
            actionData: JSON.parse(getActionData()),      //功能按钮每个页面必须用

            listLoading: false,
            form: {
                PageIndex: 1,
                PageSize: 10,

                ProtocolNo: '',         //协议编号
                ProtocolVersion: '',    //协议版本
                ProtocolName: '',       //协议名称
                CreateTime: [],         //创建时间
                ProtocolFileName: '',   //协议文件
                ProtocolType: 1,       //协议类型
            },
            searchData:{},
            oraginForm:{},
            total: 0,                       //总条数
            tableData:[],

            showContract: false,
            dialogTitle: '',

            url: apiEnv.uploadURLImg,
            addForm: {
                ProtocolVersion: '',        //版本
                ProtocolName: '',           //名称
                ProtocolLinkUrl: '',        //连接
                ProtocolFileUrl: '',        //pdfUrl
            },
        }
    },
    activated(){},
    created() {
        this.oraginForm = JSON.parse(JSON.stringify(this.form))
        this.tableData = [];
        this.handleSearch()
    },
    computed: {
    },
    mounted() {
    },
    methods: {
        // table切换 
        chose(type){
            this.form.ProtocolType = type;
            this.handleSearch()
        },
        //渲染列表
        handleSearch() {
            this.searchData = Object.assign({}, this.form)
            this.handleCurrentChange(1)
        },
        handleCurrentChange(val) {
            if (this.listLoading) return
            this.form.PageIndex = val
            this.searchData.PageIndex = val
            this.GetListContractTerms()
        },
        //翻页
        handleSizeChange(val) {
        if (this.listLoading) return
            this.form.PageIndex = 1
            this.form.PageSize = val
            this.searchData.PageIndex = 1
            this.searchData.PageSize = val
            this.GetListContractTerms()
        },
        async GetListContractTerms(){
            this.listLoading = true
            let data = JSON.parse(JSON.stringify(this.searchData))
            !data.ProtocolNo && delete data.ProtocolNo
            !data.ProtocolVersion && delete data.ProtocolVersion
            !data.ProtocolName && delete data.ProtocolName
            !data.ProtocolFileName && delete data.ProtocolFileName
            if (data.CreateTime && data.CreateTime.length) {
                data.CreateStartTime = data.CreateTime[0]
                data.CreateEndTime = data.CreateTime[1]
            }
            delete data.CreateTime
            let res = await ListContractTerms(data)
            this.listLoading = false
            if(res.Result != 1) {
                return this.$message.error('获取失败请联系开发人员')
            }
            this.tableData = res.Data.List
            this.total = res.Data.TotalRows
        },
        handleReset() {
            this.form = JSON.parse(JSON.stringify(this.oraginForm))
            this.handleSearch()
        },

        // 新增
        addContract(){
            this.showContract = true
            this.dialogTitle = this.form.ProtocolType==1?'新增使用协议':'新增隐私条款'
            this.addForm = {
                ProtocolVersion: '',        //版本
                ProtocolName: '',           //名称
                ProtocolLinkUrl: '',        //连接
                ProtocolFileUrl: '',        //pdfUrl
            }
        },
        // 上传前
        uploadPreview(file){
            const isIMAGE = file.type === 'application/pdf'
            const isLt100M = file.size / 1024 / 1024 < 100;
            if(!isIMAGE) {
                this.$message.error('上传文件只能是pdf格式');
            }
            if (!isLt100M) {
                this.$message.error('上传pdf大小不能超过 100MB!');
            }
            return isLt100M && isIMAGE;
        },
        // 上传pdf
        protocolFileSuccess(res){
            if(res.Result != 1) return this.$message.error(res.Message)
            this.addForm.ProtocolFileUrl = res.Data[0].imgUrl
        },
        // 保存新增
        save(){
            let data = {
                ...this.addForm
            }
            if(!data.ProtocolVersion) return this.$message.warning('版本不能为空！');
            if(!data.ProtocolName) return this.$message.warning('名称不能为空！');
            if(!data.ProtocolLinkUrl) return this.$message.warning('连接不能为空！');
            if(!data.ProtocolFileUrl) return this.$message.warning('文件不能为空！');
            data['ProtocolType'] = this.form.ProtocolType
            AddContractTerms(data).then(res=>{
                if (res.Result != 1) {
                    return this.$message.error(res.Message);
                }
                this.$message.success("保存成功");
                this.showContract = false;
                this.addForm = {
                    ProtocolVersion: '',        //版本
                    ProtocolName: '',           //名称
                    ProtocolLinkUrl: '',        //连接
                    ProtocolFileUrl: '',        //pdfUrl
                }
                this.GetListContractTerms();
            })
        },
    }
  }
</script>

<style lang="scss">
    .el-row {
        margin-bottom: 20px;
        &:last-child {
        margin-bottom: 0;
        }
    }
    .row-bg {
        padding: 10px 14px;
        background-color: #f9fafc;
    }
    .sent-post {
        .selected {
            color: #409EFF;
            border-color: #c6e2ff;
            background-color: #ecf5ff;
        }
    }
    .add-form {
        .img-item {
            width: 146px;
            height: 146px;
            vertical-align: top;
            caret-color: transparent;
            span {
                display: block;
                width: 100%;
                height: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
            }
            &:hover:after {
                border: none !important
            }
        }
        .itmes-file {
            width: 146px;
            height: 146px;
            position: relative;
            overflow: hidden;
            border: 1px solid #ebeef5;
            margin-right: 30px;
            &:hover {
                .delete-this-dom {
                    opacity: 1;
                }
            }
        }
        .delete-this-dom {
            position: absolute;
            right:0px;
            top: 0px;
            width: 18px;
            height: 18px;
            z-index: 2;
            opacity: 0;
            transition: all .2s ease-in-out;
            -webkit-transition: all .2s ease-in-out;
            -moz-transition: all .2s ease-in-out;
            -o-transition: all .2s ease-in-out;
            border: 1px solid #f75959;
            line-height: 18px;
            text-align: center;
            background: rgba(255,255,255,1);
        }
    }
</style>